module.exports = __webpack_public_path__ + "assets/img/honor12.ca33a4a1.jpg";